module.exports = __webpack_public_path__ + "img/gold-discount-icon.a76158f2.png";